import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const siteInfoTasksRequest = createRequest(constants.siteInfoTasks);
export const siteInfoTasksSuccess = createSuccess(constants.siteInfoTasks);
export const siteInfoTasksFailure = createFailure(constants.siteInfoTasks);

export const requestSiteInfoTasks = siteInfoTasksRequest;
